import { ADD_TO_CART_PROPERTY_UNITS } from "../../../Constants/CartConstants";

const CartPropertyUnitReducer = (
  state = 0,
  action: { type: string; payload: number },
) => {
  switch (action.type) {
    case ADD_TO_CART_PROPERTY_UNITS:
      return action.payload;
    default:
      return state;
  }
};

export default CartPropertyUnitReducer;
